import { pick } from 'ramda';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentConfig } from 'js/hooks/component';
import { useGetErrorMessage } from 'js/hooks/server';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';

import * as server from './server';
import * as helpers from './heplers';
import * as actions from '../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../store';

export const useFetchComponent = () => {
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();
    const { showLoginTable, showTotalLoginCount } = useComponentConfig();
    const formatter = useFormatter();
    const {
        page: { pageId },
        endDate,
        startDate
    } = useDynamicReducerSelector(pick([
        'page',
        'endDate',
        'startDate'
    ]));

    useUpdateEffect(() => {
        if (!showLoginTable && !showTotalLoginCount) {
            return;
        }

        dispatch(actions.setData({ error: '', isLoading: true }));

        (async () => {
            try {
                const response = await server.getLoginHistory({
                    returnTotalCount: showTotalLoginCount,
                    ...showLoginTable && { pageId },
                    loginDateBeforeDate: formatter.getDateForIms(endDate),
                    loginDateAfterDate: formatter.getDateForIms(startDate)
                });

                dispatch(actions.updateHistory(helpers.parse(response.data)));
            } catch (error) {
                const errorMsg = getErrorMessage(error);

                dispatch(actions.setData({ error: errorMsg }));
            } finally {
                dispatch(actions.setData({ isLoading: false }));
            }
        })();
    }, [dispatch, getErrorMessage, showTotalLoginCount, pageId, endDate, startDate, formatter, showLoginTable]);
};
